<template>
    <div>
        <VAside :sidebar-menus="sidebarMenus" headerHeight="50">
            <router-view></router-view>
        </VAside>
    </div>
</template>

<script>
export default {
  data() {
    return {
      sidebarMenus: [
        { index: 'console_config', title: 'Console配置', icon: 'fa fa-life-ring', name: 'console_config' },
        { index: 'oauth_client_config', title: 'OauthClient配置', icon: 'fa fa-cog', name: 'oauth_client_config' },
      ],
    };
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// system_config_manage.vue?3a9f42e4